export const tabs = [
  {
    label: 'sensorGroups',
    value: 'SensorGroups'
  },
  {
    label: 'individualSensors',
    value: 'IndividualSensors'
  },
  {
    label: 'alarms',
    value: 'SensorAlarms'
  },
  {
    label: 'reportSettings',
    value: 'ReportSettings'
  }
];
